import "./NameAvatar.css";

export const NameAvatar = ({
  firstName,
  lastName,
  width,
  height,
  classes,
  size,
}) => {
  const AvatarName = () => {
    if (firstName && lastName) {
      return `${firstName[0]} ${lastName[0]}`;
    } else if (!firstName && lastName) {
      return `${lastName[0]}`;
    } else if (!lastName && firstName) {
      return `${firstName[0]}`;
    } else {
      return `N/A`;
    }
  };

  return (
    <>
      <div
        className={`${classes} AvatarContainer`}
        style={{ width: width, height: height, fontSize: size }}
      >
        {AvatarName()}
      </div>
    </>
  );
};
